





























import mixins from 'vue-typed-mixins';
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { MenuItem } from '@/route-mapping';
import { User, Location } from '@/Stores/UserStore';
import { supportedLocales } from '@/internationalization';
import Roles from '@/Shared/Roles';
import { stringCompare } from '@/Shared/Utilities';
import NavMenu from '@/Shared/NavMenu.vue';
import UserMixin from '@/Shared/UserMixin';

const LocationRoot = mixins(UserMixin).extend({
    components: {
        NavMenu
    },
    props: {
        location: {
            required: false,
            type: String,
        }
    },
    computed: {
        showMenu(): boolean {
            return this.isInternal;
        }
    }
});

export default LocationRoot;
